import { ISignupForm } from '@models/ISignupForm';
import SignupForm from '@organisms/SignupForm/SignupForm';

interface Props extends ISignupForm {
  readonly contactList?: string;
  readonly disabled: boolean;
  readonly disabledMessage: string;
}

const NewsletterSignupForm = ({ disabled, disabledMessage, ...rest }: Props) =>
  disabled ? (
    <section className="bg-white">
      <h2 className="h4 container py-20 xl:py-40">{disabledMessage}</h2>
    </section>
  ) : (
    <SignupForm fullPage {...rest} />
  );

export default NewsletterSignupForm;
